/* src/app/modules/ct-status/components/cts-gantry-init-status/cts-gantry-init-status.component.scss */
:host {
  display: block;
}
.gantry-init-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  gap: 1rem;
}
.gantry-init-header sh-text {
  width: fit-content;
  white-space: nowrap;
}
.gantry-events-container {
  margin-top: 1rem;
  display: flex;
  flex-wrap: nowrap;
  gap: 0.5rem;
  padding-bottom: 0.5rem;
  overflow-x: auto;
}
@media only screen and (max-width: 1600px) {
  .gantry-events-container {
    min-width: 100%;
    max-width: 45.75rem;
  }
}
.gantry-init-title {
  display: flex;
  gap: 1em;
  width: 100%;
  align-items: center;
}
.gantry-som-informative {
  display: flex;
  gap: 0.5rem;
  width: 100%;
  justify-content: right;
  align-items: center;
}
.gantry-som-informative sh-text {
  width: fit-content;
}
.gantry-api-call-gate {
  margin: 0;
}
.gantry-description {
  align-items: center;
  white-space: nowrap;
  display: inline-flex;
  gap: 1rem;
  width: 100%;
}
.gantry-description sh-text {
  width: fit-content;
}
.no-more-events {
  flex: 1;
  box-sizing: border-box;
  text-align: center;
  display: flex;
  height: 3rem;
  min-width: 6.75rem;
  width: 100%;
  border-radius: 0.5rem;
  border: 1px solid #ccc;
  align-items: center;
}
/*# sourceMappingURL=cts-gantry-init-status.component.css.map */
